export const xhr = async (resource, options = {}) => new Promise((resolve, reject) => {
	const req = new XMLHttpRequest();
	req.addEventListener('load', () => resolve({
		status: req.status,
		ok: req.status >= 200 && req.status < 300,
		text: async () => req.responseText,
		json: async () => JSON.parse(req.responseText),
		blob: async () => new Blob([req.responseText]),
	}));
	req.addEventListener('error', reject);
	req.addEventListener('abort', reject);
	if (options.onUploadProgress) {
		req.upload.addEventListener('progress', e => options.onUploadProgress(e, options.id));
	}
	req.open(options.method || 'GET', resource);
	if (options.credentials === 'include') req.withCredentials = true;
	if (options.headers) {
		Object.entries(options.headers).forEach(header => req.setRequestHeader(...header));
	}
	req.send(options.body);
});